import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AutoConfirmedAlert, ConfirmPassword } from '@adjust/dashboard-components';

import { connectWithStore } from '@common/connectWithStore';
import { SidebarId } from '@react/constants/sidebars';
import { resetApiToken, closeAlert } from '@redux/ducks/userDetails/apiToken';

import { EditUserApiTokenContent } from './EditUserApiTokenContent';

const EditUserApiToken = ({ user, resetApiToken, closeAlert, onCancel, isLoading, trace, isAlertOpen }) => {
  // Close Alert when the component is unmounting
  useEffect(
    () => () => {
      if (isAlertOpen) {
        closeAlert();
      }
    },
    [isAlertOpen, closeAlert],
  );

  const [isConfirmPasswordOpen, setIsConfirmPasswordOpen] = useState(false);
  const { status, message } = trace;
  const onPasswordConfirm = passwordPayload => {
    setIsConfirmPasswordOpen(false);
    resetApiToken(passwordPayload);
  };

  return (
    <>
      <EditUserApiTokenContent
        authenticationToken={user.authentication_token}
        onReset={() => setIsConfirmPasswordOpen(true)}
        onCancel={onCancel}
        isLoading={isLoading}
      />
      <ConfirmPassword
        parentSidebarId={SidebarId.UserDetails}
        isOpen={isConfirmPasswordOpen}
        onCancel={() => setIsConfirmPasswordOpen(false)}
        onConfirm={passwordPayload => onPasswordConfirm(passwordPayload)}
      />
      <AutoConfirmedAlert
        parentSidebarId={SidebarId.UserDetails}
        isOpen={isAlertOpen}
        type={status}
        message={message}
        onConfirm={closeAlert}
      />
    </>
  );
};

EditUserApiToken.propTypes = {
  user: PropTypes.object,
  resetApiToken: PropTypes.func,
  closeAlert: PropTypes.func,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  trace: PropTypes.object,
  isAlertOpen: PropTypes.bool,
};

const mapStateToProps = state => ({
  isLoading: state.userDetails.apiToken.isResettingToken,
  trace: state.userDetails.apiToken.trace,
  isAlertOpen: state.userDetails.apiToken.isAlertOpen,
});

const mapDispatchToProps = {
  resetApiToken,
  closeAlert,
};

export default connectWithStore(mapStateToProps, mapDispatchToProps)(EditUserApiToken);

export { EditUserApiToken };
